import { LanguagePreference } from '../../interface';
import { useLanguagePreferencesStore } from '../../store';
import './index.css';

export const LanguageSwitcher = () => {
  const { currentLanguagePreference, setLanguagePreference } =
    useLanguagePreferencesStore();

  const toggleLanguage = () => {
    const newLang =
      currentLanguagePreference === LanguagePreference.LATVIAN
        ? LanguagePreference.ENGLISH
        : LanguagePreference.LATVIAN;
    setLanguagePreference(newLang);
  };

  return (
    <button className="language-switcher" onClick={toggleLanguage}>
      {currentLanguagePreference === LanguagePreference.LATVIAN ? 'EN' : 'LV'}
    </button>
  );
};
